import { useEffect, useState } from "react";
import { useParams } from "react-router";

import { getOriginal, getVideo } from "../../../../utils/imgUri";
import { generateUUID } from "../../../../utils/uuid";
import { getOrientation } from "../utils/common";

import { useSlides } from "../../Builder/store";

import defaultVideoThumbnail from "../../../../assets/builder/def-vid-thumb.jpeg";

export function useMount(variant, formik) {
	let { id: isEditing } = useParams();
	const [isReady, setIsReady] = useState(false);
	const slides = useSlides(state => state[variant]);
	const isPopulated = useSlides(state => state.isPopulated);
	const setCurrentVariant = useSlides(state => state.setCurrentVariant);
	const setActiveSlide = useSlides(state => state.setActiveSlide);
	const setIsPopulated = useSlides(state => state.setIsPopulated);
	const modifySlide = useSlides(state => state.modifySlide);

	const asyncPopulator = async arr => {
		let orArr = [];
		for (const str of arr) {
			if (str.image) {
				let original = getOriginal(str.image);
				let res = await getOrientation(original);
				orArr.push(res);
			} else {
				orArr.push("squere");
			}
		}
		for (let i = 0; i < arr.length; i++) {
			if (!slides[i]?.isEdited) {
				if (arr[i].image) {
					let original = getOriginal(arr[i].image);
					modifySlide(i, {
						...slides[0],
						index: generateUUID(),
						png: original,
						orientation: orArr[i],
						isPreview: true,
					});
				} else {
					let video = getVideo(formik.values.gallery[i].video);
					modifySlide(i, {
						...slides[0],
						index: generateUUID(),
						png: defaultVideoThumbnail,
						orientation: orArr[i],
						isPreview: true,
						isVideo: true,
						video,
					});
				}
			}
			setIsPopulated(true);
		}
		setIsReady(true);
	};

	useEffect(() => {
		setCurrentVariant(variant);
		setActiveSlide(0);
		if (isEditing) {
			if (variant === "gallery") {
				if (!isPopulated) {
					asyncPopulator(formik.values.gallery);
				} else {
					setIsReady(true);
				}
			} else {
				if (!slides[0].isEdited) {
					let original = getOriginal(formik.values.logo);
					modifySlide(0, {
						...slides[0],
						png: original,
						isPreview: true,
					});
				}
				setIsReady(true);
			}
		} else {
			setIsReady(true);
		}
	}, []);

	return [isReady];
}
